import { useRemoteContentStore } from '../../stores/remoteContent.store';
import React, { useEffect } from 'react';
import DOMPurify from 'dompurify';
import { Carousel } from 'ehs-react';
import type { at } from '../../generated/Beans';
type RemoteContent = at.sense.portlets.saf.virtualvisitpatient.model.RemoteContent;

export function RemoteContentCarousel(): JSX.Element {
  const [remotePages, getData, loaded] = useRemoteContentStore(state => [
    state.remotePages,
    state.getData,
    state.loaded
  ]);

  useEffect(() => {
    if (!loaded) {
      getData();
    }
  }, [loaded, getData]);

  return (
    <div className="vvpp-remote-content">
      {loaded && (
        <Carousel arrows controls dots="bottom" duration={500} initial={0}>
          {remotePages.length > 0 &&
            loaded &&
            remotePages.map(item => (
              <CarouselElement remotePage={item} key={item.id} />
            ))}
        </Carousel>
      )}
    </div>
  );
}

function CarouselElement(props: { remotePage: RemoteContent }): JSX.Element {
  const decode = (): string => {
    const ele = document.createElement('div');
    ele.innerHTML = props.remotePage.content;
    const htmlRet =
      ele.childNodes.length == 0 ? '' : ele.childNodes[0].nodeValue;
    return htmlRet || '';
  };
  const cont = '<hr />' + decode();
  return (
    <div
      className="vvpp-remote-content-element"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(cont)
      }}
    />
  );
}
